import {h, Component} from 'preact'
import {connect} from 'react-redux'
import reduce from '../reducers'
import * as actions from '../actions'
import constants from "../constants";
import store from "../store";
import {setLayoutGuides} from "../canvas/layout-guides";

export default @connect(reduce, actions)
class LayoutGuideBar extends Component {
    constructor() {
        super();

        this.useLayoutGuide = this.useLayoutGuide.bind(this);
        this.changePageMargin = this.changePageMargin.bind(this);
        this.changeColumnMargin = this.changeColumnMargin.bind(this);
        this.getValue = this.getValue.bind(this);
    }

    useLayoutGuide(layout) {
        store.dispatch(actions.setLayoutGuide(layout));
        setLayoutGuides(layout, this.props.layoutGuidePageMargin, this.props.layoutGuideColumnMargin);
    }

    getValue(ev, MAX) {
        let value = ev.target.value;
        let number = parseFloat(value);

        if (value < 0) {
            value = '0';
            number = 0;
        }

        if (value > MAX) {
            value = `${MAX}`;
            number = MAX;
        }

        return [value, number];
    }

    changePageMargin(ev) {
        if (!ev.target.value || ev.target.value === '.') return;
        const [value, number] = this.getValue(ev, this.props.designUnit === 'in' ? 2 : 100);

        store.dispatch(actions.setLayoutGuidePageMargin(value));
        setLayoutGuides(this.props.layoutGuide, number, this.props.layoutGuideColumnMargin);
    }

    changeColumnMargin(ev) {
        if (!ev.target.value || ev.target.value === '.') return;
        const [value, number] = this.getValue(ev, this.props.designUnit === 'in' ? 2 : 100);

        store.dispatch(actions.setLayoutGuideColumnMargin(value));
        setLayoutGuides(this.props.layoutGuide, this.props.layoutGuidePageMargin, value);
    }

    render (props, state) {
        return (
            <div className="context-bar ly-gd-br">
                <ul style={{width: '100%'}}>
                    <li>
                        <a className={props.layoutGuide === 1 ? 'act' : ''} onClick={() => this.useLayoutGuide(1)}><svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-layout-guide-1" }/></svg></a>
                    </li>
                    <li>
                        <a className={props.layoutGuide === 2 ? 'act' : ''} onClick={() => this.useLayoutGuide(2)}><svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-layout-guide-3" }/></svg></a>
                    </li>
                    <li>
                        <a className={props.layoutGuide === 3 ? 'act' : ''} onClick={() => this.useLayoutGuide(3)}><svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-layout-guide-2" }/></svg></a>
                    </li>
                    <li>
                        <a className={props.layoutGuide === 4 ? 'act' : ''} onClick={() => this.useLayoutGuide(4)}><svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-layout-guide-4" }/></svg></a>
                    </li>
                    <li>
                        <a className={props.layoutGuide === 5 ? 'act' : ''} onClick={() => this.useLayoutGuide(5)}><svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-layout-guide-5" }/></svg></a>
                    </li>
                    <li className={'sm'}>
                        <div className="dropdown">
                            <a className="dropdown-toggle icn rwd-icon">Margins</a>
                            <div className="dropdown-menu" data-close="no">
                                <div>
                                    <label>page margin</label>
                                    <input type="number" step={props.designUnit === 'in' ? '.1' : '1'} min={0} value={props.layoutGuidePageMargin} onChange={this.changePageMargin} onKeyUp={this.changePageMargin}/>
                                    <span className="unit">{props.designUnit}</span>
                                </div>
                                <div>
                                    <label>column margin</label>
                                    <input type="number" step={props.designUnit === 'in' ? '.1' : '1'} min={0} value={props.layoutGuideColumnMargin} onChange={this.changeColumnMargin} onKeyUp={this.changeColumnMargin}/>
                                    <span className="unit">{props.designUnit}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className={'lg'}>
                        <div className={'szr'} style={{marginRight: '15px'}}>
                            <label>page margin</label>
                            <input type="number" step={props.designUnit === 'in' ? '.1' : '1'} min={0} value={props.layoutGuidePageMargin} onChange={this.changePageMargin} onKeyUp={this.changePageMargin}/>
                            <span className="unit">{props.designUnit}</span>
                        </div>
                        <div className={'szr'}>
                            <label>column margin</label>
                            <input type="number" step={props.designUnit === 'in' ? '.1' : '1'} min={0} value={props.layoutGuideColumnMargin} onChange={this.changeColumnMargin} onKeyUp={this.changeColumnMargin}/>
                            <span className="unit">{props.designUnit}</span>
                        </div>
                    </li>
                </ul>
            </div>
        )
    }
}
